import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "toolbar py-5 py-lg-15",
  id: "kt_toolbar"
}
const _hoisted_2 = { class: "page-title d-flex flex-column me-3" }
const _hoisted_3 = { class: "d-flex text-white fw-bolder my-1 fs-3" }
const _hoisted_4 = {
  key: 0,
  class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1"
}
const _hoisted_5 = { class: "breadcrumb-item text-white opacity-75" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_7 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item text-white opacity-75" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1)
const _hoisted_8 = { class: "breadcrumb-item text-white opacity-75" }
const _hoisted_9 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item text-white opacity-75" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1)
const _hoisted_10 = { class: "breadcrumb-item text-white opacity-75" }
const _hoisted_11 = { class: "d-flex align-items-center py-3 py-md-1" }
const _hoisted_12 = { class: "me-4" }
const _hoisted_13 = {
  href: "#",
  class: "\n              btn\n              btn-custom\n              btn-active-white\n              btn-flex\n              btn-color-white\n              btn-active-color-primary\n              fw-bolder\n            ",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_14 = { class: "svg-icon svg-icon-5 svg-icon-gray-500 me-1" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Filter ")
const _hoisted_16 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "btn btn-bg-white btn-active-color-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_create_app",
  id: "kt_toolbar_primary_button"
}, " Create ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown1 = _resolveComponent("Dropdown1")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      id: "kt_toolbar_container",
      class: [{
        'container-fluid': _ctx.toolbarWidthFluid,
        'container-xxl': !_ctx.toolbarWidthFluid,
      }, "d-flex flex-stack flex-wrap"]
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
        (_ctx.breadcrumbs)
          ? (_openBlock(), _createBlock("ul", _hoisted_4, [
              _createVNode("li", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: "/dashboard",
                  class: "text-white"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _hoisted_7,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (item, index) => {
                return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                  _createVNode("li", _hoisted_8, _toDisplayString(item), 1),
                  _hoisted_9
                ], 64))
              }), 128)),
              _createVNode("li", _hoisted_10, _toDisplayString(_ctx.title), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _createVNode("a", _hoisted_13, [
            _createVNode("span", _hoisted_14, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen031.svg" })
            ]),
            _hoisted_15
          ]),
          _createVNode(_component_Dropdown1)
        ]),
        _hoisted_16
      ])
    ], 2)
  ]))
}